const baseUrl = 'http://182.70.244.242:8080/v1'
// const baseUrl = 'http://localhost:4002/v1'

export default baseUrl
